export const DeadlineListPublish = () => {
    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">마감 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">상태</label>
                            <select className="form-select me-0">
                                <option>미 마감</option>
                            </select>
                            <button className="btn btn-info btn_search">
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                            </button>
                        </div>
                        <div className="frm_row search justify-content-start">
                            <label for="" className="form-label frm_label">세금계산서 마감일</label>
                            <select className="form-select w-150px me-0">
                                <option>2023-11-16</option>
                            </select>
                            <button className="btn btn-info btn_search">저장</button>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="frm_row">
                            <label for="" className="form-label frm_label">출하일자</label>
                            <div className="frm_field input_date">
                                <input type="date" className="form-control" />
                                <span className="txt_range">~</span>
                                <input type="date" className="form-control me-0" />
                                <button className="btn btn-info btn_search">
                                    <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt="" />조회
                                </button>
                            </div>
                        </div>
                        <div className="frm_row">
                            <label for="" className="form-label frm_label">환율 일괄 적용</label>
                            <div className="frm_field">
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="option1" />
                                    <label className="form-check-label" for="inlineRadio1">전월 평균</label>
                                </div>
                                <div className="form-check form-check-inline">
                                    <input className="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="option2" />
                                    <label className="form-check-label" for="inlineRadio2">기간 평균</label>
                                </div>
                            </div>
                        </div>
                        <div className="frm_row">
                            <label for="" className="form-label frm_label"></label>
                            <div className="frm_field input_date">
                                <input type="date" className="form-control" />
                                <span className="txt_range">~</span>
                                <input type="date" className="form-control" />
                                <input type="text" className="form-control me-0" />
                                <button className="btn btn-info btn_search w-80px">적용</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">마감 목록(<span>13</span>건)</h6>
                    <div className="table_toolbar">
                        <button className="btn btn-outline-dark w-150px"><img src={process.env.PUBLIC_URL + "/assets/images/icon_import.png"} alt="" />엑셀 가져오기</button>
                        <button className="btn btn-dark w-150px px-0"><img src={process.env.PUBLIC_URL + "/assets/images/icon_export.png"} alt="" />엑셀 내보내기</button>
                        <button className="btn btn-primary ms-40px">세금 계산서 발행</button>
                        <button className="btn btn-info color2 w-80px">마감</button>
                        <button className="btn btn-outline-info w-80px px-0">마감취소</button>
                        <button className="btn btn-outline-dark"><img src={process.env.PUBLIC_URL + "/assets/images/icon_cross.png"} alt="" />선택삭제</button>
                    </div>
                </div>

                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <thead>
                            <tr>
                                <th style={{ width: "3.76%" }}>
                                    <div className="checkbox_outer">
                                        <input
                                            className="form-check-input"
                                            type="checkbox"
                                        />
                                    </div>
                                </th>
                                <th>출하일자</th>
                                <th>마감일자</th>
                                <th>담당자</th>
                                <th>고객사</th>
                                <th>매출처</th>
                                <th>환종</th>
                                <th>환율</th>
                                <th>공급가액</th>
                                <th>부가세</th>
                                <th>금액</th>
                                <th>상태</th>
                            </tr>
                        </thead>
                        <tbody>
                            {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, index) => (
                                <tr className={item === 9 ? "lightblue" : ""}>
                                    <td className="text-center">
                                        <div className="checkbox_outer">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                            />
                                        </div>
                                    </td>
                                    <td className="text-center">2024.01.10</td>
                                    <td className="text-center">2024.01.10</td>
                                    <td className="text-center">홍길동</td>
                                    <td className="text-center">고객사</td>
                                    <td className="text-center">주식회사 구구구</td>
                                    <td className="text-center">KRW</td>
                                    <td className="text-end">12,345</td>
                                    <td className="text-end">0</td>
                                    <td className="text-end">0</td>
                                    <td className="text-end">0</td>
                                    <td className="text-center">미 마감</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="pagination-container">
                    <ul>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_first.png"}
                                alt="First Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_prev.png"}
                                alt="Previous Page"
                                className=""
                            />
                        </li>
                        <li className="active">1</li>
                        <li className="">2</li>
                        <li className="">3</li>
                        <li className="">4</li>
                        <li className="">5</li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_next.png"}
                                alt="Next Page"
                                className=""
                            />
                        </li>
                        <li className="pg_nav">
                            <img
                                src={process.env.PUBLIC_URL + "/assets/images/pg_last.png"}
                                alt="Last Page"
                                className=""
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </>
    );
}